import { render, staticRenderFns } from "./GeneralConfig.vue?vue&type=template&id=0b2ac832&scoped=true"
import script from "./GeneralConfig.vue?vue&type=script&lang=js"
export * from "./GeneralConfig.vue?vue&type=script&lang=js"
import style0 from "./GeneralConfig.vue?vue&type=style&index=0&id=0b2ac832&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2ac832",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b2ac832')) {
      api.createRecord('0b2ac832', component.options)
    } else {
      api.reload('0b2ac832', component.options)
    }
    module.hot.accept("./GeneralConfig.vue?vue&type=template&id=0b2ac832&scoped=true", function () {
      api.rerender('0b2ac832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mealOrder/mealView/mealConfig/components/GeneralConfig.vue"
export default component.exports